import { useState } from 'react';
import { useEffectOnce } from 'react-use';

import { useLazyGetApiParentHelperTopicsQuery } from 'applications/GSP/shared/api/gsp';

import { useLoadMore } from './hooks';

import type {
  SetChatId,
  SetChatTopics,
} from 'applications/GSP/pages/ParentHelper/types';

export const useGetChatTopics = (
  setChatId: SetChatId,
  setChatTopics: SetChatTopics,
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [getChatTopics, { data }] = useLazyGetApiParentHelperTopicsQuery();

  const { loadMore, isLoadingMore } = useLoadMore({
    getChatTopics,
    nextPageUrl: data?.nextPageUrl,
    setChatTopics,
  });

  useEffectOnce(() => {
    setIsLoading(true);
    getChatTopics({ continuationToken: '' })
      .unwrap()
      .then(({ topics }) => {
        if (topics.length) {
          setChatId(topics[0].chatId);
          setChatTopics(topics);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  });

  return {
    isLoading,
    loadMore,
    isLoadingMore,
    data,
  };
};
